"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @ignore */
exports.connectionForNodes = (nodes) => ({
    edges: [
        ...nodes.map(node => ({ node }))
    ]
});
/** @ignore Creates an empty connection object */
exports.emptyConnection = () => ({
    edges: []
});
/** @ignore Creates a connection object with a single node, applying any parameterized overrides */
exports.singleNodeConnection = (node, overrides = null) => ({
    edges: [
        {
            node: Object.assign({}, node, overrides)
        }
    ]
});
